import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth, API } from "@/context/AuthContext";
import { Flame, Loader2 } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setSessionFromOAuth } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;
        if (!sessionId) {
            toast.error("Missing session id — please try signing in again.");
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const res = await axios.post(`${API}/auth/session`, { session_id: sessionId });
                setSessionFromOAuth(res.data.access_token, res.data.user);
                // Clear the hash before navigating
                window.history.replaceState(null, "", window.location.pathname);
                toast.success(`Welcome, ${res.data.user.name.split(" ")[0]}.`);
                navigate("/app", { replace: true });
            } catch (err) {
                toast.error(err?.response?.data?.detail || "Sign-in failed. Please try again.");
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setSessionFromOAuth]);

    return (
        <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-6">
            <div className="flex flex-col items-center gap-4" data-testid="oauth-callback">
                <Flame className="w-6 h-6 text-signal" />
                <Loader2 className="w-5 h-5 text-signal animate-spin" />
                <div className="text-xs font-mono uppercase tracking-widest text-zinc-500">Completing sign-in…</div>
            </div>
        </div>
    );
}
